import React from 'react';
import Load from './Load';
import { Liga } from '../types/liga';
import { Organizador } from '../services/organizadorService';

interface LeagueSidebarProps {
  liga: Liga;
  organizadores: Organizador[];
  organizadoresLoading: boolean;
  organizadorPrincipal: Organizador | null;
  isAdmin: boolean;
  isOwnLeague: boolean;
  seguidorUserId: string;
  followId: string | null;
  loadingSeguir: boolean;
  erroSeguir: string;
  onSeguir: () => Promise<void>;
  formatarDataCriacao: (dataString: string) => string;
  formatarTelefoneWhatsApp: (telefone: string | null | undefined) => string;
  onVerTorneios?: () => void;
}

const LeagueSidebar: React.FC<LeagueSidebarProps> = ({
  liga,
  organizadores,
  organizadoresLoading,
  organizadorPrincipal,
  isAdmin,
  isOwnLeague,
  seguidorUserId,
  followId,
  loadingSeguir,
  erroSeguir,
  onSeguir,
  formatarDataCriacao,
  formatarTelefoneWhatsApp,
  onVerTorneios,
}) => {
  return (
    <div className="col-md-4 mb-3 mb-md-0">
      <div className="d-flex flex-column gap-3">
        {/* Botão Torneios */}
        <button
          className="btn btn-primary w-100"
          onClick={() => onVerTorneios?.()}
        >
          Ver Torneios
        </button>

        {/* Botão Seguir */}
        {!isAdmin && !isOwnLeague && seguidorUserId && (
          <div>
            <button
              onClick={onSeguir}
              disabled={loadingSeguir}
              className={`btn w-100 ${followId ? 'btn-secondary' : 'btn-primary'}`}
            >
              {loadingSeguir
                ? 'Aguarde...'
                : followId
                ? 'Seguindo'
                : 'Seguir'}
            </button>
            {erroSeguir && (
              <div className="alert alert-danger mt-2 mb-0" role="alert">
                {erroSeguir}
              </div>
            )}
          </div>
        )}

        {/* Seção Sobre */}
        <div className="card border-0 bg-grey">
          <div className="card-body">
            <h5 className="fw-700 text-grey-900 font-xss mb-3">Sobre</h5>
            {liga.criadoEm && (
              <p className="font-xssss text-grey-700 mb-0">
                Criada em {formatarDataCriacao(liga.criadoEm)}
              </p>
            )}
          </div>
        </div>

        {/* Seção Contatos */}
        {organizadorPrincipal && (
          <div className="card border-0 bg-grey">
            <div className="card-body">
              <h5 className="fw-700 text-grey-900 font-xss mb-3">Contatos</h5>
              <div className="d-flex flex-column gap-2">
                <div>
                  <p className="font-xssss fw-600 text-grey-900 mb-1">
                    {organizadorPrincipal.nome || organizadorPrincipal.usuario?.nome || 'Organizador'}
                  </p>
                  {organizadorPrincipal.usuario?.email && (
                    <p className="font-xssss text-grey-700 mb-1">
                      {organizadorPrincipal.usuario.email}
                    </p>
                  )}
                  {organizadorPrincipal.telefone && (
                    <p className="font-xssss text-grey-700 mb-2">
                      {organizadorPrincipal.telefone}
                    </p>
                  )}
                </div>
                {organizadorPrincipal.telefone && (
                  <a
                    href={`https://wa.me/${formatarTelefoneWhatsApp(organizadorPrincipal.telefone)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-success btn-sm w-100"
                  >
                    <i className="bi bi-whatsapp me-2"></i>
                    Mensagem
                  </a>
                )}
              </div>
            </div>
          </div>
        )}
        {organizadoresLoading && (
          <div className="text-center">
            <Load />
          </div>
        )}
        {!organizadoresLoading && organizadores.length === 0 && (
          <div className="card border-0 bg-grey">
            <div className="card-body">
              <h5 className="fw-700 text-grey-900 font-xss mb-3">Contatos</h5>
              <p className="font-xssss text-grey-700 mb-0">
                Nenhum contato disponível.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LeagueSidebar;
